import React from 'react';
import { KeyboardAvoidingView, View } from 'react-native';
import { isAndroid } from '../../utils/Helper';
import { useCssStyle } from '../../customHook/getCssStyle';

const KeyboardAvoidingWrapper = ({ children, style, keyboardVerticalOffset = 0}) => {

  const getStyles = useCssStyle();

  if (isAndroid()) {
    return (
      <KeyboardAvoidingView style={getStyles([{flex: 1, ...style}])} behavior={'padding'} keyboardVerticalOffset={keyboardVerticalOffset}>
        {children}
      </KeyboardAvoidingView>
    )
  }

  return <>{children}</>;
};


export default KeyboardAvoidingWrapper;